import request from '../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../types/enums/request-enums';

export interface AIProcessLogItem {
    id: number;
    predictionId: string;
    username: string;
    productBarcode: string;
    prompt: string;
    imageUrls: string; // JSON string array
    outputUrl: string;
    numImages: number;
    aspectRatio: string;
    resolution: string;
    outputFormat: string;
    status: string;
    cost?: number;
    predictionTimeSeconds?: number;
    createdDate: string;
    completedDate?: string;
    isInpainting?: boolean;
    modelType?: number; // 0: EachLabs, 1: Google Gemini
    generationTypeCode?: string;
    generationTypeName?: string;
}

export interface AIProcessLogQueryResponse {
    items?: AIProcessLogItem[];
    data?: AIProcessLogItem[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const GetUserHistory = (params: { 
    pageNumber?: number; 
    pageSize?: number;
    barcode?: string;
}): Promise<AIProcessLogQueryResponse> => {
    const { pageNumber = 1, pageSize = 12, barcode } = params;
    let url = `${ApiURL.Query.StudioQueryURLs.AIProcessLogQueryURL.GetUserHistory}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    
    if (barcode && barcode.trim()) {
        url += `&barcode=${encodeURIComponent(barcode.trim())}`;
    }
    
    return request({
        url,
        method: RequestType.GET,
    });
};

const GetHistoryDetail = (id: number): Promise<AIProcessLogItem> => {
    return request({
        url: ApiURL.Query.StudioQueryURLs.AIProcessLogQueryURL.GetHistoryDetail(id),
        method: RequestType.GET,
    });
};

const AIProcessLogQuery = {
    GetUserHistory,
    GetHistoryDetail,
};

export default AIProcessLogQuery;

